export function msToParts(ms) {
    const totalSeconds = Math.floor(ms / 1000);
    return {
        hours: Math.floor(totalSeconds / 3600),
        minutes: Math.floor((totalSeconds % 3600) / 60),
        seconds: totalSeconds % 60,
    };
}
/**
 * Parse the API's average completion format (a .NET TimeSpan): "H:MM:SS",
 * "H:MM:SS.fff", or "D.HH:MM:SS(.fff)" once it reaches a day. Days fold into hours.
 */
export function parseHmsString(value) {
    if (!value)
        return null;
    const match = /^(?:(\d+)\.)?(\d+):(\d+):(\d+)(?:\.\d+)?$/.exec(value.trim());
    if (!match)
        return null;
    const [, days, hours, minutes, seconds] = match;
    return {
        hours: Number(days ?? 0) * 24 + Number(hours),
        minutes: Number(minutes),
        seconds: Number(seconds),
    };
}
/** Total milliseconds represented by an API completion-time string (see `parseHmsString`), or undefined if unparsable. */
export function hmsToMs(value) {
    const parts = parseHmsString(value);
    if (!parts)
        return undefined;
    return ((parts.hours * 60 + parts.minutes) * 60 + parts.seconds) * 1000;
}
/** ETA-style: "~3h" | "~12 min" | "~45s" — highest non-zero unit only. */
export function formatEtaFromMs(ms) {
    const { hours, minutes, seconds } = msToParts(ms);
    if (hours > 0)
        return `~${hours}h`;
    if (minutes > 0)
        return `~${minutes} min`;
    return `~${seconds}s`;
}
/** Digital-clock format: "01:23:45" (hours omitted when zero). */
export function formatHmsClock(parts) {
    const h = parts.hours > 0 ? String(parts.hours).padStart(2, '0') + ':' : '';
    const m = String(parts.minutes).padStart(2, '0');
    const s = String(parts.seconds).padStart(2, '0');
    return `${h}${m}:${s}`;
}
/** Verbose elapsed: "1h 23m 45s" — drops zero leading units. */
export function formatElapsedHms(parts) {
    const out = [];
    if (parts.hours)
        out.push(`${parts.hours}h`);
    if (parts.minutes)
        out.push(`${parts.minutes}m`);
    if (!parts.hours && (parts.seconds || !parts.minutes))
        out.push(`${parts.seconds}s`);
    return out.join(' ');
}
/** Pluralized words: "1 hour 23 minutes" / "45 secs". */
export function formatVerboseHms(parts) {
    const { hours, minutes, seconds } = parts;
    const segments = [];
    if (hours > 0)
        segments.push(`${hours} ${hours > 1 ? 'hours' : 'hour'}`);
    if (minutes > 0)
        segments.push(`${minutes} ${minutes > 1 ? 'minutes' : 'minute'}`);
    if (seconds > 0 && minutes === 0 && hours === 0)
        segments.push(`${seconds} secs`);
    return segments.join(' ');
}
